import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const ContextOneTwo = () => {
    return (
        <div className="App">
            <div className="App-body">
                <p>
                    Nearby, various items scattered around Nina's cubicle catch your eye, particularly 
                    those colored vibrantly. As you turn your attention to her laptop, you're confronted 
                    with a password prompt. To unlock the laptop, you must use the clues found in the memo 
                    pad and the items left around her desk to decipher the password. This color-coding 
                    seems to be a deliberate clue left for anyone astute enough to notice.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/BoxOne/PuzzleOne'>Go to Puzzle One</Button>
            </div>
        </div>
    );
  };
  
export default ContextOneTwo;